import styled from "styled-components";

const Container = styled.div`
  z-index: 1;
  width: 90%;
  max-width: 1170px;
  margin: 0 auto;
`;

export default Container;
